import React from "react";
import "./App.css";
import { App } from "visual-chat-builder";
import { IS_AGENT_MODE, IS_NO_CODE } from "./constants.ts";
import "../node_modules/visual-chat-builder/dist/index.css";
import "@cometchat/chat-uikit-react/css-variables.css";
function VcbPreviewApp() {
  return (
    <div className="App" id="cb-preview-app">
      <App
        isNoCode={IS_NO_CODE}
        isAgentMode={IS_AGENT_MODE}
        isPreviewScreen
      />
    </div>
  );
}

export default VcbPreviewApp;
